import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { DeliveryType } from 'app/models/user-order.model';

export const stateSelector = createSelector(
  (state: AppState) => state.state,
  s1 => s1
);

export const currentAddressSelector = createSelector(
  (state: AppState) => state.state,
  s1 => s1.currentAddress
);

export const currentDeliveryZoneSelector = createSelector(
  (state: AppState) => state.state,
  s1 => s1.currentZone
);

export const deliveryTerminalSelector = createSelector(
  stateSelector,
  (state) => {
    return state.currentAddress ? state.currentAddress.deliveryTerminal : null;
  }
);
export const minSumSelector = createSelector(
  stateSelector,
  state => state.currentZone ? state.currentZone.minSum : null
);

export const isPickupSelector = createSelector(
    stateSelector,
    state => state.currentAddress ? state.currentAddress.type === DeliveryType.PICKUP : false
);

export const deliveryZoneDetailsSelector = createSelector(
  stateSelector,
  state => {

    const maxDate = null;
    let deliveryTimeMinutes = 60;
    if (state.currentAddress) {
      deliveryTimeMinutes = state.currentAddress.deliveryTerminal.cookingTimeInMinutes;
      if (state.currentAddress.type === DeliveryType.DELIVERY) {
        if (state.currentZone && state.currentZone.deliveryDurationInMinutes) {
          deliveryTimeMinutes = state.currentZone.deliveryDurationInMinutes;
        } else {
          deliveryTimeMinutes = state.currentAddress.deliveryTerminal.cookingTimeInMinutes + 30;
        }
      }
    }

    const minDate = new Date();
    minDate.setTime(
      minDate.getTime() + deliveryTimeMinutes * 60 * 1000
    );

    return {
      minDate,
      maxDate
    };
  }
)
